import { render, staticRenderFns } from "./ProgramPublishing.vue?vue&type=template&id=b1017bf6&scoped=true&"
import script from "./ProgramPublishing.vue?vue&type=script&lang=js&"
export * from "./ProgramPublishing.vue?vue&type=script&lang=js&"
import style0 from "./ProgramPublishing.vue?vue&type=style&index=0&id=b1017bf6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1017bf6",
  null
  
)

export default component.exports